"use strict";

/*
 * Search widget for mainmenu
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var Widget = function Widget() {
    var me = this;

    //Св-ва
    var options = {
      //Шапка сайта
      header: null,
      //Ссылка на кнопку главного меню "гамбургер"
      topMenuBtn: null,
      //Контейнер с анимацией для кнопки главного меню
      topMenuBtnAnimate: null,
      //Ссылка на контейнер, содержащий основной контент
      topMenuContent: null
    };

    //Инициализация виджета
    this.init = function () {
      me.initParam();
      me.initEvents();
    };

    // Инициализация параметров
    this.initParam = function () {
      options.header = $('.header');
      options.topMenuBtn = $('#topMenuBtn');
      options.topMenuBtnAnimate = options.topMenuBtn.find('[class=btn-animate]');
      options.topMenuContent = $('#topMenuContent');

      // Заголовок в шапке
      //let title = $('title').text();
      //let indexOfDelimiter = title.indexOf('/');
      //let cutTitleFromIndex = indexOfDelimiter > -1 ? indexOfDelimiter + 2 : 0;

      //$('.menu-page-title h5').text(title.substring(cutTitleFromIndex, title.length));
    };

    // Инициализация событий
    this.initEvents = function () {
      // Клик на кнопку главного меню
      options.topMenuBtn.on('click', function () {
        // Отобразить/скрыть меню
        me.toggleMenu();
      });
      var timer = null;
      // Если указатель мыши выходит за рамки меню, оно скрывается через 0.5сек.
      // Если в течение 0.5сек вернуться, меню не скроется

      options.topMenuContent.on("mouseover", function () {
        clearTimeout(timer);
      }).on("mouseleave", function () {
        if (!options.topMenuContent.is(":visible")) return;
        timer = setTimeout(function () {
          me.toggleMenu();
        }, 750);
        return;
      });
    };

    // Отобразить/скрыть меню
    this.toggleMenu = function (callback) {
      // Запустить/скрыть анимацию кнопки
      options.topMenuBtnAnimate.toggleClass("open");

      // Запустить/скрыть анимацию меню
      options.topMenuContent.animate({
        opacity: "toggle"
        //                width: "toggle"
      }, 200, function () {
        callback && callback();
      });
    };

    // Отобразить меню
    this.show = function () {
      //Анимация открытия метю
      options.topMenuContent.show("slide", {
        direction: "left"
      }, 200, function () {});
    };

    // Скрыть меню
    this.hide = function () {
      //Анимация закрытия меню
      options.topMenuContent.hide("slide", {
        direction: "left"
      }, 200);
    };
  };
  var instance = new Widget();
  $(document).ready(function () {
    instance.init();
  });
})(jQuery);